import { render, staticRenderFns } from "./viewItemReleaseRes.vue?vue&type=template&id=2e7fef73"
import script from "./viewItemReleaseRes.vue?vue&type=script&lang=js"
export * from "./viewItemReleaseRes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports